import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Form } from "rsuite";
import { AppRouteUi } from "../../../config/appRoute";
import { useAuthFunc } from "../../../libs/hooks";
import { AuthLayout } from "../../components/authLayout";
import {
  PasswordInput,
  TextInput,
} from "../../../components/textInput.component";
import { Button } from "../../../components/button.component";

export function PageAuthLogin(): JSX.Element {
  const { state } = useLocation<{ passwordReset?: boolean; from?: string }>();

  const [userName, setUserName] = React.useState<string>();
  const [password, setPassword] = React.useState<string>();
  const { isBusy, logIn } = useAuthFunc();

  return (
    <AuthLayout>
      <h4 className="text-center fw-light">Login</h4>
      {state?.from === "reset" && (
        <div
          className={`bg-${
            state?.passwordReset ? "success" : "danger"
          } text-white py-2 my-2 text-center rounded`}
        >
          {state?.passwordReset ? "Password changed" : "Password reset failed"}
        </div>
      )}
      <Form className="py-3 border-bottom" fluid>
        <div className="px-4 pb-3">
          <TextInput
            name="UserName"
            onChange={(value) => setUserName(`${value}`)}
            fullWidth
            required
          >
            User Name
          </TextInput>
          <PasswordInput
            name="Password"
            onChange={(value) => setPassword(`${value}`)}
            fullWidth
            required
          >
            Password
          </PasswordInput>
        </div>

        <div className="d-flex justify-content-center">
          <Button
            className="mt-3 px-5 btn-green"
            type="submit"
            name="Login"
            onClick={() =>
              userName && password
                ? logIn({ userName, password, rememberMe: true })
                : void 0
            }
            disabled={!userName || !password}
            loading={isBusy}
          />
        </div>

        <Link
          to={AppRouteUi.Login.ForgotPassword()}
          className={`text-green-200 px-4 mt-3 text-center d-block ${
            isBusy ? "pe-none" : ""
          }`}
        >
          Forgot Password?
        </Link>
        <Link
          to={AppRouteUi.Login.RegisterCompany()}
          className={`text-green-200 px-4 text-center d-block ${
            isBusy ? "pe-none" : ""
          }`}
        >
          Want to register your company?
        </Link>
      </Form>
      <div className="d-flex justify-content-center">
        <a
          href={AppRouteUi.PrivacyPolicy.Root()}
          className={`text-capitalize text-green-300 px-4 mt-3 text-center d-block ${
            isBusy ? "pe-none" : ""
          }`}
        >
          privacy policy
        </a>
      </div>
    </AuthLayout>
  );
}
